import { Col, Row } from "react-bootstrap";
import { InfoCircleFill } from "react-bootstrap-icons";
import moment from "moment/min/moment-with-locales";
import RATooltip from "../RATooltip";
import { Suspense, useMemo } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";

export default function ComparisonSongsRow({ comparisonData, item, virtualizer, virtualRow, setCatalogueSong, showFirstOn = false }) {
    const { radios, competitorRadios } = useRouteLoaderData("root");
    const allRadiosPromise = useMemo(() => Promise.all([radios, competitorRadios]), [competitorRadios, radios]);

    return (
        <Row
            key={virtualRow.key}
            data-index={virtualRow?.index}
            ref={virtualizer?.measureElement}
            onClick={() => setCatalogueSong(item)}
            style={{ transform: `translateY(${virtualRow?.start ?? 0}px)` }}
            className={`py-1 border-bottom w-100 position-absolute align-items-center hoverable fs-8-xs`}>
            <Col xs={"auto"} className="pe-0 align-content-center fw-bold d-xl-none ">
                #{virtualRow?.index + 1}
            </Col>
            <Col xs={"auto"} xl className=" align-content-center fw-bold fw-xl-normal">
                {item.artist}
            </Col>
            <Col xs="auto" className=" align-content-center px-0 d-xl-none">
                -
            </Col>
            <Col xs={"auto"} xl className=" align-content-center fw-bold fw-xl-normal">
                {item.title}
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={2} className=" align-self-center text-center">
                <span className=" d-xl-none">Release year: </span>
                <span className=" fw-bold fw-xl-normal">{item.release_year}</span>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>

            <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                <span className=" d-xl-none">Spins: </span>
                {item.radio_spin && item.radio_spin.length >= 2 ? item.radio_spin[0].spins + item.radio_spin[1].spins : item.spins}
            </Col>
            {showFirstOn && (
                <>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className="d-xl-none">Spins A: </span>
                        {item.radio_spin?.find(spin => spin.radio_id === comparisonData?.input?.radio_ids?.[0])?.spins ?? 0}
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className="d-xl-none">Spins B: </span>
                        {item.radio_spin?.find(spin => spin.radio_id === comparisonData?.input?.radio_ids?.[1])?.spins ?? 0}
                    </Col>

                    <Col xs={12} className="d-xl-none"></Col>
                    <Col xs={"auto"} xl={2} className=" align-self-center text-xl-center text-start">
                        <Suspense>
                            <Await resolve={allRadiosPromise}>
                                {([resolvedRadios, resolvedCompetitorRadios]) => {
                                    const combinedRadios = resolvedRadios.data.concat(resolvedCompetitorRadios.data);
                                    return (
                                        <>
                                            <span className=" d-xl-none ">First played on: </span>
                                            <span className=" fw-bold fw-xl-normal">{combinedRadios.find(x => x.radio_id === item.first_on)?.radio_name} </span>
                                            <span className=" d-xl-none">at: </span>
                                            <span className=" d-xl-none fw-bold">{moment(item.first_play).format("L")}</span>
                                        </>
                                    );
                                }}
                            </Await>
                        </Suspense>
                    </Col>
                </>
            )}
            {showFirstOn ? (
                <Col xs={"auto"} className=" d-none d-xl-block">
                    <RATooltip tooltipElement={<InfoCircleFill />}>
                        <>
                            <span>
                                Rank: <strong>{virtualRow?.index + 1}</strong>
                            </span>
                            <br />
                            <span>
                                First played: <strong>{moment(item.first_play).format("L")}</strong>
                            </span>
                        </>
                    </RATooltip>
                </Col>
            ) : (
                <Col xs={"auto"} className=" d-none d-xl-block">
                    <RATooltip tooltipElement={<InfoCircleFill />}>
                        <>
                            <span>
                                Rank: <strong>{virtualRow?.index + 1}</strong>
                            </span>
                            <br />
                            <span>
                                First played: <strong>{moment(item.first_play).format("L")}</strong>
                            </span>
                        </>
                    </RATooltip>
                </Col>
            )}
        </Row>
    );
}
